import { h } from "omi";

import { IconProps } from "@/wc/components";

export function ThumbsDownIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20" fill="none" width={width} height={height}>
      <path
        d="M14.6667 1.66675V10.8334M18.8333 8.16675V4.33341C18.8333 3.39999 18.8333 2.93328 18.6517 2.57676C18.4919 2.26316 18.2369 2.00819 17.9233 1.8484C17.5668 1.66675 17.1001 1.66675 16.1667 1.66675H7.26501C6.04711 1.66675 5.43816 1.66675 4.94632 1.88961C4.51284 2.08603 4.14442 2.4021 3.88437 2.80068C3.58931 3.25291 3.49672 3.85478 3.31153 5.05852L2.87563 7.89185C2.63137 9.47951 2.50925 10.2733 2.74484 10.891C2.95162 11.4332 3.34054 11.8865 3.84494 12.1733C4.41961 12.5001 5.22278 12.5001 6.82912 12.5001H7.5C7.96671 12.5001 8.20007 12.5001 8.37833 12.5909C8.53513 12.6708 8.66261 12.7983 8.74251 12.9551C8.83334 13.1333 8.83334 13.3667 8.83334 13.8334V16.2785C8.83334 17.4134 9.75333 18.3334 10.8882 18.3334C11.1589 18.3334 11.4042 18.174 11.5141 17.9266L14.3148 11.6252C14.4421 11.3386 14.5058 11.1953 14.6065 11.0902C14.6955 10.9974 14.8048 10.9263 14.9258 10.8827C15.0627 10.8334 15.2195 10.8334 15.5332 10.8334H16.1667C17.1001 10.8334 17.5668 10.8334 17.9233 10.6518C18.2369 10.492 18.4919 10.237 18.6517 9.9234C18.8333 9.56688 18.8333 9.10017 18.8333 8.16675Z"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
